const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const formElementFields = [
  {
    id: "quote_expiry_days",
    label: "Quote Expiry Days",
    placeHolder: "",
    type: "text",
    md: 4,
    inputProps: {
      maxLength: 4,
    },
    patternAllowed: patternConstant?.NUMERIC,
    // isRequired: true,
  },

  {
    id: "minimum_profit_level",
    label: "Minimum Profit Level (%)",
    placeHolder: "Enter minimum profit level",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    inputProps: {
      maxLength: 6,
    },
    // firstColmd: 1.5,
    md: 4,
  },
  {
    id: "is_minimum_profit_required",
  label: "\u00A0",
    checkLabel: "Minimum Profit Required",
    placeHolder: "Enter rate",
    type: "checkbox",
    md: 4,
  },
  {
    id: "minimum_profit_level_message",
    label: "Minimum Profit Level Message",
    placeHolder: "",
    type: "textarea",
    md: 12,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
  },
];

export const SALE_DETAILS_FIELDS = [
  {
    id: "quote_expiry_days",
    label: "Quote Expiry Days",
    placeHolder: "Enter Payment Terms",
    type: "viewField",
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "minimum_profit_level",
    label: "Minimum Profit Level (%)",
    placeHolder: "Enter Minimum Profit Level",
    type: "viewField",
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.PERCENTAGE,
  },
  {
    id: "is_minimum_profit_required",
    label: "Minimum Profit Required",
    placeHolder: "Enter Minimum Profit Required",
    type: "viewField",
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "minimum_profit_level_message",
    label: "Minimum Profit Level Message",
    placeHolder: "Enter Minimum Profit Level Message",
    type: "viewField",
    inputProps: {
      marginBottom: "10px",
    },
    md: 12,
  },
];
